// eslint-disable-next-line spire/fenced-imports
import { RecursivePartial } from "@insite/shell/Components/Shell/StyleGuide/Types";
import accordion from "@stoneage/XDL/PreStyle/accordion";
import breadcrumbs from "@stoneage/XDL/PreStyle/breadcrumbs";
import breakpoints from "@stoneage/XDL/PreStyle/breakpoints";
import button from "@stoneage/XDL/PreStyle/button";
import checkbox from "@stoneage/XDL/PreStyle/checkbox";
import clickable from "@stoneage/XDL/PreStyle/clickable";
import colors from "@stoneage/XDL/PreStyle/colors";
import dataTable from "@stoneage/XDL/PreStyle/dataTable";
import datePicker from "@stoneage/XDL/PreStyle/datePicker";
import drawer from "@stoneage/XDL/PreStyle/drawer";
import dynamicDropdown from "@stoneage/XDL/PreStyle/dynamicDropdown";
import fieldSet from "@stoneage/XDL/PreStyle/fieldSet";
import fileUpload from "@stoneage/XDL/PreStyle/fileUpload";
import focus from "@stoneage/XDL/PreStyle/focus";
import formField from "@stoneage/XDL/PreStyle/formField";
import globalStyle from "@stoneage/XDL/PreStyle/globalStyle";
import helpers from "@stoneage/XDL/PreStyle/helpers";
import icon from "@stoneage/XDL/PreStyle/icon";
import lazyImage from "@stoneage/XDL/PreStyle/lazyImage";
import link from "@stoneage/XDL/PreStyle/link";
import lists from "@stoneage/XDL/PreStyle/lists";
import loadingSpinner from "@stoneage/XDL/PreStyle/loadingSpinner";
import menu from "@stoneage/XDL/PreStyle/menu";
import modal from "@stoneage/XDL/PreStyle/modal";
import overflowMenu from "@stoneage/XDL/PreStyle/overflowMenu";
import pagination from "@stoneage/XDL/PreStyle/pagination";
import panelMenu from "@stoneage/XDL/PreStyle/panelMenu";
import radio from "@stoneage/XDL/PreStyle/radio";
import select from "@stoneage/XDL/PreStyle/select";
import shadows from "@stoneage/XDL/PreStyle/shadows";
import tab from "@stoneage/XDL/PreStyle/tab";
import tag from "@stoneage/XDL/PreStyle/tag";
import textArea from "@stoneage/XDL/PreStyle/textArea";
import textField from "@stoneage/XDL/PreStyle/textField";
import toast from "@stoneage/XDL/PreStyle/toast";
import tokenExFrame from "@stoneage/XDL/PreStyle/tokenExFrame";
import tooltip from "@stoneage/XDL/PreStyle/tooltip";
import transition from "@stoneage/XDL/PreStyle/transition";
import translate from "@stoneage/XDL/PreStyle/translate";
import typography from "@stoneage/XDL/PreStyle/typography";
import zIndex from "@stoneage/XDL/PreStyle/zIndex";
import { xBaseTheme } from "@stoneage/XDL/types";

export default {
    breakpoints,
    colors,
    focus,
    // shadows,
    // transition,
    globalStyle,
    typography,
    zIndex,
    accordion,
    breadcrumbs,
    button,
    checkbox,
    // clickable,
    dataTable,
    // datePicker,
    drawer,
    dynamicDropdown,
    // fileUpload,
    // formField,
    // fieldSet,
    // icon,
    link,
    lists,
    // lazyImage,
    loadingSpinner,
    // menu,
    modal,
    overflowMenu,
    // pagination,
    // panelMenu,
    radio,
    select,
    tab,
    tag,
    // textField,
    // tokenExFrame,
    // textArea,
    toast,
    tooltip,
    // translate,
    helpers,
} as RecursivePartial<xBaseTheme>;
